import React, { useState, Fragment } from 'react'
import { Grid, Input } from 'semantic-ui-react'

export default function TextFieldQuestion({item, data, handleInputChange, t}) {
    
    return (
        <Fragment>
            <Grid.Row>
                <Grid.Column>
                    <div className="input-container theme-color">
                        <label className='label'>{t("general.text.placeholder")}</label>
                        <Input 
                            value={data.question} 
                            name="question"
                            type="question"
                            autoComplete="off" 
                            onChange={(e, {value}) => handleInputChange({name: "question", value})}
                            placeholder={t("general.text.placeholder")} />
                    </div>
                </Grid.Column>
            </Grid.Row>
        </Fragment>
    )
}
